module.exports = __webpack_public_path__ + "static/media/progressiveIcon.63a9d9f8.svg";